import React from 'react';
import { useState, useEffect, useRef } from 'react';
import _ from 'lodash';
import ToastElement from "../../../../Components/UiComponents/ToastElement";
import Loader from "../../../../Components/UiComponents/Loader";
import { Accordion, AccordionTab } from 'primereact/accordion';
import { Tooltip } from 'primereact/tooltip';
import CalendarElement from '../../../../Components/UiComponents/CalendarElement';
import RadioElement from '../../../../Components/UiComponents/RadioElement';
import ButtonElement from '../../../../Components/UiComponents/ButtonElement';
import MultiSelectElement from '../../../../Components/UiComponents/MultiSelectElement';
import CheckboxElement from '../../../../Components/UiComponents/CheckboxElement';
import InputTextElementElement from '../../../../Components/UiComponents/InputTextElement';
import SingleSelectElement from '../../../../Components/UiComponents/SingleSelectElement';
import { InputIcon } from "primereact/inputicon";
import { Dialog } from 'primereact/dialog';
import TextareaElement from '../../../../Components/UiComponents/TextareaElement';
import DataTable from '../../../../Components/UiComponents/DataTable';
import { saveDoc, deleteFile, submissionActionComplete } from '../../../../Services/opportunityService';
import Moment from "moment";
import ExcelUploader from './ExcelUploader';
import { useOpportunity } from '../../../../Providers/OpportunityContext';
import socket from '../../../../socket';
import { clearCompletedNotification } from '../../../../Services/notificationService';
import { useNavigate } from 'react-router-dom';
import PlaylistVideos from '../../../../Components/Videos/PlaylistVideos';

const QuestionAndAnswer = (props) => {
	const [loading, setLoading] = useState(false);
	const [newModule, setNewModule] = useState({});
	const [opportunityData, setOpportunityData] = useState({});
	const [previousStatusData, setPreviousStatusData] = useState({});
	const [showDropdown, setShowDropdown] = useState(false);
	const [selectedIndex, setSelectedIndex] = useState({});
	const [submissionManagementModal, setSubmissionManagementModal] = useState(false);
	const [editDoc, setEditDoc] = useState(false);
	const [docData, setDocData] = useState({});
	const [attachment, setAttachment] = useState([]);
	const [tempDelete, setTempDelete] = useState([]);
	const [selectedOwner, setSelectedOwner] = useState([]);
	const [selectedStatus, setSelectedStatus] = useState([]);
	const [submissionManagementCompletedModal, setSubmissionManagementCompletedModal] = useState(false);
	const [isUserActionOwnerSameSub, setIsUserActionOwnerSameSub] = useState(false);
	const [ittStatus, setIttStatus] = useState({});
	const [pqqStatus, setPqqStatus] = useState({});
	const [docDataTemp, setDocDataTemp] = useState({});
	const [upload, setUpload] = useState(false);
	const [showVideo, setShowVideo] = useState(false);
	const { setGlobalOpportunityData } = useOpportunity();
	const navigate = useNavigate()
	const toastRef = useRef();

	const enduser = localStorage.getItem("enduser");
	if (enduser) {
		var tmpData = JSON.parse(enduser);
		if (tmpData === null) {
			navigate("/login")
			localStorage.clear()
		}
	}

	const curCustomer = tmpData.customer;

	useEffect(() => {
		if (props.fieldData.pipelineSubSections) {
			let obj1 = _.find(props?.fieldData?.pipelineSubSections, { section_name: "Document Response Status" })?.display_name;
			let obj2 = _.find(props?.fieldData?.pipelineSubSections, { section_name: "Document Response Management" })?.display_name;
			let combined = { obj1, obj2 };
			setNewModule(combined)
		}
	}, [props.fieldData.pipelineSubSections])

	useEffect(() => {
		if (props.opportunityData) {
			setOpportunityData(props.opportunityData)
			initSubmissionTab(props.opportunityData)
		}
	}, [props.opportunityData])

	useEffect(() => {
		if ((editDoc || !editDoc) && !_.isEmpty(docData)) {
			setSubmissionManagementModal(true)
		}
	}, [editDoc, docData])

	useEffect(() => {
		setGlobalOpportunityData((prevData) => ({
			...prevData,
			documents: opportunityData.documents
		}));
	}, [opportunityData.documents]);

	useEffect(() => {
		setGlobalOpportunityData((prevData) => ({
			...prevData,
			detail: {
				...prevData.detail,
				eoi_received_date: opportunityData.detail?.eoi_received_date,
				pqq_issue_date: opportunityData.detail?.pqq_issue_date,
				pqq_submission_date: opportunityData.detail?.pqq_submission_date,
				itt_submission_date: opportunityData.detail?.itt_submission_date
			},
		}));
	}, [opportunityData.detail]);

	useEffect(() => {
		setGlobalOpportunityData((prevData) => ({
			...prevData,
			tender_due: opportunityData.tender_due,
		}));
	}, [opportunityData.tender_due]);

	useEffect(() => {
		setGlobalOpportunityData((prevData) => ({
			...prevData,
			tender_due_out: opportunityData.tender_due_out
		}));
	}, [opportunityData.tender_due_out]);

	const calcStageScore = (stage, opportunityDetails) => {
		var result = {
			completion: 0,
			sumOfEstimatedMarks: 0,
			sumOfMaxMarks: 0,
			sumOfMarksAchieved: 0,
		};
		var numberOfQuestions = 0;
		var index = _.findIndex(opportunityDetails.documents, { document_type: stage });
		if (index != -1) {
			_.filter(
				opportunityDetails.documents[index].questions,
				function (question) {
					_.filter(question.sub_questions, function (sub_question) {
						//Completion
						numberOfQuestions += 1;
						var optionIndex = _.findIndex(props.submissionDocStatus, {
							_id: sub_question.status,
						});
						if (optionIndex != -1) {
							result.completion += props.submissionDocStatus[optionIndex].score ? props.submissionDocStatus[optionIndex].score : 0;
						}
						//Current estimated Marks
						result.sumOfEstimatedMarks += sub_question.current_estimated_marks ? Number(sub_question.current_estimated_marks) : 0;
						result.sumOfMaxMarks += sub_question.maximum_marks_available ? Number(sub_question.maximum_marks_available) : 0;
						result.sumOfMarksAchieved += sub_question.marks_achieved ? Number(sub_question.marks_achieved) : 0;
					});
				}
			);
		}
		var value = result.completion / numberOfQuestions;
		result.completion = value ? value : 0;
		result.completion = result.completion % 1 == 0 ? result.completion : result.completion.toFixed(2);

		return result;
	};

	const calcSubmissionScore = (PParentIndex, parentIndex, index, status, docLabel, questionLabel, opportunityDetails) => {
		if (!_.isEmpty(opportunityDetails.documents)) {
			var pqqStatus = calcStageScore("PQQ", opportunityDetails);
			var ittStatus = calcStageScore("ITT", opportunityDetails);
			setPqqStatus(pqqStatus)
			setIttStatus(ittStatus)
		} else {
			var pqqStatus = {
				completion: 0,
				sumOfEstimatedMarks: 0,
				sumOfMaxMarks: 0,
				sumOfMarksAchieved: 0,
			};
			var ittStatus = {
				completion: 0,
				sumOfEstimatedMarks: 0,
				sumOfMaxMarks: 0,
				sumOfMarksAchieved: 0,
			};
			setPqqStatus(pqqStatus)
			setIttStatus(ittStatus)
		}

		var storedStatus = ''
		if (status != undefined && label != "Ready For Client") {
			storedStatus = !_.isEmpty(opportunityDetails.documents) && opportunityDetails.documents[PParentIndex].questions[parentIndex].sub_questions[index].status;
		}

		var subheadFlag = false
		if (questionLabel == "") {
			subheadFlag = false;
		} else {
			subheadFlag = true;
		}
		var docDataTemp = {};

		if (typeof (status) == 'string') {
			var label = _.find(props.submissionDocStatus, { _id: status }) != undefined ? _.find(props.submissionDocStatus, { _id: status }).label : null;
		} else {
			var label = _.find(props.submissionDocStatus, { _id: status._id }) != undefined ? _.find(props.submissionDocStatus, { _id: status._id }).label : null;
		}

		if (label == "Ready For Client") {
			docDataTemp = {
				PParentIndex: PParentIndex,
				parentIndex: parentIndex,
				index: index,
				docLabel: docLabel,
				questionLabel: questionLabel,
				status: opportunityDetails.documents[PParentIndex].questions[parentIndex].sub_questions[index].status,
			};
			if (opportunityDetails.documents[PParentIndex].questions[parentIndex].sub_questions[index]._id != undefined) {
				if (opportunityDetails.documents[PParentIndex].questions[parentIndex].sub_questions[index].action_owner === tmpData.userid) {
					setIsUserActionOwnerSameSub(true);
					setSubmissionManagementCompletedModal(true)
				} else {
					setIsUserActionOwnerSameSub(false);
					setSubmissionManagementCompletedModal(true)
				}
			} else {
				toastRef.current.showToast({
					type: 'error',
					message: "Please save the task"
				});

				setOpportunityData(prevOpportunityData => {
					const updatedData = { ...prevOpportunityData };
					updatedData.documents[PParentIndex].questions[parentIndex].sub_questions[index].status = "";
					return updatedData;
				});
			}
			setDocDataTemp(docDataTemp)
		}
	};

	const initSubmissionTab = (opportunityDetails) => {
		var selectedDoc_index = -1;
		var selectedQuestion_index = -1;
		var pqqStatus = {
			completion: 0,
			sumOfEstimatedMarks: 0,
			sumOfMaxMarks: 0,
			sumOfMarksAchieved: 0,
		};
		var ittStatus = {
			completion: 0,
			sumOfEstimatedMarks: 0,
			sumOfMaxMarks: 0,
			sumOfMarksAchieved: 0,
		};
		setSelectedIndex({
			docIndex: selectedDoc_index,
			questionIndex: selectedQuestion_index
		})

		setPqqStatus(pqqStatus)
		setIttStatus(ittStatus)

		calcSubmissionScore(0, 0, 0, '', '', '', opportunityDetails);
	};

	const parseDateString = (dateString) => {
		if (dateString != '' && dateString != undefined) {
			const [day, month, year] = dateString.split('-')?.map(Number);
			return new Date(year, month - 1, day);
		}
	};

	const formatDate = (input) => {
		const date = (input instanceof Date) ? input : new Date(input);
		const day = String(date.getDate()).padStart(2, '0');
		const month = String(date.getMonth() + 1).padStart(2, '0');
		const year = date.getFullYear();
		return `${day}-${month}-${year}`;
	};

	const handleInputChange = (field1, field2, value) => {
		setOpportunityData((prevOpportunityDetails) => ({
			...prevOpportunityDetails,
			[field1]: {
				...prevOpportunityDetails[field1],
				[field2]: {
					...prevOpportunityDetails[field1][field2],
					radio: value,
				},
			},
		}));
	};

	const handleCalenderInputChange = (field1, field2, value) => {
		setOpportunityData((prevOpportunityDetails) => ({
			...prevOpportunityDetails,
			[field1]: {
				...prevOpportunityDetails[field1],
				[field2]: {
					...prevOpportunityDetails[field1][field2],
					text: value,
				},
			},
		}));
	};

	const handleTenderInputChange = (field1, value) => {
		setOpportunityData((prevOpportunityDetails) => ({
			...prevOpportunityDetails,
			[field1]: {
				...prevOpportunityDetails[field1],
				radio: value,
			},
		}));
	};

	const handleCalenderTenderInputChange = (field1, value) => {
		setOpportunityData((prevOpportunityDetails) => ({
			...prevOpportunityDetails,
			[field1]: {
				...prevOpportunityDetails[field1],
				text: value,
			},
		}));
	};

	const resetButton = () => {
		var owner = []
		var status = []
		setSelectedOwner(owner)
		setSelectedStatus()
		filterSubData(owner, status)
		setShowDropdown(false)
	}

	const toggleDropdown = () => {
		setShowDropdown(!showDropdown)
	}

	const removeSelected = () => {
		if (selectedIndex.docIndex != -1 && selectedIndex.questionIndex == -1) {
			opportunityData.documents.splice(selectedIndex.docIndex, 1);
			selectedIndex.docIndex = -1;
			calcSubmissionScore(0, 0, 0, '', '', '', opportunityData);
		} else if (selectedIndex.docIndex != -1 && selectedIndex.questionIndex != -1) {
			var length = opportunityData.documents[selectedIndex.docIndex].questions.length;
			if (length > 1) {
				opportunityData.documents[selectedIndex.docIndex].questions.splice(selectedIndex.questionIndex, 1);
				selectedIndex.docIndex = -1;
				selectedIndex.questionIndex = -1;
			} else {
				toastRef.current.showToast({
					type: 'error',
					message: "Section should have atleast one question"
				});
			}
			calcSubmissionScore(0, 0, 0, '', '', '', opportunityData);
		}

		setOpportunityData((prevState) => ({
			...prevState,
			['documents']: opportunityData.documents
		}))
	}

	const addNew = () => {
		if (_.isEmpty(opportunityData.documents)) {
			opportunityData.documents.push(
				{
					document_type: "PQQ",
					label: props.fieldData.submissionLabels.PQQLabel,
					questions: [
						{
							question_name: "",
							sub_questions: [
								{
									current_estimated_marks: 0,
									maximum_marks_available: 0,
									marks_achieved: 0,
								},
							],
						},
					],
				},
				{
					document_type: "ITT",
					label: props.fieldData.submissionLabels.ITTLabel,
					questions: [
						{
							question_name: "",
							sub_questions: [
								{
									current_estimated_marks: 0,
									maximum_marks_available: 0,
									marks_achieved: 0,
								},
							],
						},
					],
				}
			);
		} else if (selectedIndex.docIndex != -1 && selectedIndex.questionIndex == -1) {
			opportunityData.documents[selectedIndex.docIndex].questions.push(
				{
					question_name: "",
					sub_questions: [
						{
							current_estimated_marks: 0,
							maximum_marks_available: 0,
							marks_achieved: 0,
						},
					],
				}
			);
			calcSubmissionScore(0, 0, 0, '', '', '', opportunityData);
		} else if (selectedIndex.docIndex != -1 && selectedIndex.questionIndex != -1) {
			opportunityData.documents[selectedIndex.docIndex].questions[selectedIndex.questionIndex].sub_questions.push({
				current_estimated_marks: 0,
				maximum_marks_available: 0,
				marks_achieved: 0,
			});
			calcSubmissionScore(0, 0, 0, '', '', '', opportunityData);
		} else if (!_.isEmpty(opportunityData.documents)) {
			var pqqIndex = _.findIndex(opportunityData.documents, { document_type: "PQQ" });
			var ittIndex = _.findIndex(opportunityData.documents, { document_type: "ITT" });
			if (pqqIndex == -1) {
				opportunityData.documents.push({
					document_type: "PQQ",
					label: props.fieldData.submissionLabels.PQQLabel,
					questions: [
						{
							question_name: "",
							sub_questions: [
								{
									current_estimated_marks: 0,
									maximum_marks_available: 0,
									marks_achieved: 0,
								},
							],
						},
					],
				});
			} else if (ittIndex == -1) {
				opportunityData.documents.push({
					document_type: "ITT",
					label: props.fieldData.submissionLabels.ITTLabel,
					questions: [
						{
							question_name: "",
							sub_questions: [
								{
									current_estimated_marks: 0,
									maximum_marks_available: 0,
									marks_achieved: 0,
								},
							],
						},
					],
				});
			}
		}

		setOpportunityData((prevState) => ({
			...prevState,
			['documents']: opportunityData.documents
		}))
	}

	const singleSelectDoc = (position, entities, e) => {
		const updatedEntities = entities.map((subscription, index) => {
			if (position !== index) {
				return {
					...subscription,
					checked: false,
					questions: subscription.questions.map(question => ({
						...question,
						checked: false
					}))
				};
			} else {
				return {
					...subscription,
					checked: e.checked,
					questions: subscription.questions.map(question => ({
						...question,
						checked: false
					}))
				};
			}
		});

		// Create a new copy of opportunityData to trigger re-render
		const newOpportunityData = {
			...opportunityData,
			documents: updatedEntities
		};

		setOpportunityData(newOpportunityData);

		// After updating the entities, set the selectedIndex based on the updated checked key
		const updatedSection = updatedEntities[position];
		if (updatedSection && updatedSection.checked) {
			selectedIndex.docIndex = position;
			selectedIndex.questionIndex = -1;
		} else {
			selectedIndex.docIndex = -1;
			selectedIndex.questionIndex = -1;
		}

		setSelectedIndex(selectedIndex);
	}

	const singleSelectQuestion = (ind, position, doc, entities, e) => {
		const updatedEntities = entities.map((subscription, index) => {
			// Update questions array for the current subscription
			const updatedQuestions = subscription.questions.map((q, questionIndex) => {
				if (index === ind && questionIndex === position) {
					return {
						...q,  // Return updated question object
						checked: e.checked
					};
				} else {
					return {
						...q,  // Return updated question object
						checked: false
					};
				}
			});

			// Return updated subscription object with updated questions array
			return {
				...subscription,
				checked: false,  // Ensure checked is false if any question is true
				questions: updatedQuestions
			};
		});

		// Create a new copy of opportunityData to trigger re-render
		const newOpportunityData = {
			...opportunityData,
			documents: updatedEntities
		};

		setOpportunityData(newOpportunityData);

		const updatedSection = updatedEntities[ind].questions[position];

		if (updatedSection && updatedSection.checked) {
			selectedIndex.docIndex = ind;
			selectedIndex.questionIndex = position;
		} else {
			selectedIndex.docIndex = -1;
			selectedIndex.questionIndex = -1;
		}
		setSelectedIndex(selectedIndex);
	}

	const handleInputChangeName = (e, ind, index) => {
		const updatedArrayData = { ...opportunityData };
		updatedArrayData.documents[ind].questions[index].question_name = e.target.value;
		setOpportunityData(updatedArrayData);
	};

	const handlePerson = (e, ind, index, index1) => {
		const updatedArrayData = { ...opportunityData };
		updatedArrayData.documents[ind].questions[index].sub_questions[index1].action_owner = e.value._id;
		setOpportunityData(updatedArrayData);
	}

	const handleDate = (e, ind, index, index1) => {
		const updatedArrayData = { ...opportunityData };
		updatedArrayData.documents[ind].questions[index].sub_questions[index1].action_bydate = Moment(e.value).format("DD-MM-YYYY");
		setOpportunityData(updatedArrayData);
	}

	const handleStatus = (e, docIndex, questionIndex, subQuestionIndex, status, docLabel, questionLabel) => {
		var subStoreData = _.cloneDeep(opportunityData);
		setPreviousStatusData(subStoreData)

		setOpportunityData(prevOpportunityData => {
			const updatedData = { ...prevOpportunityData };
			updatedData.documents[docIndex].questions[questionIndex].sub_questions[subQuestionIndex].status = e.value._id;
			return updatedData;
		});

		calcSubmissionScore(docIndex, questionIndex, subQuestionIndex, e.value, docLabel, questionLabel, opportunityData)
	}

	const handleInputEstMarks = (e, docIndex, questionIndex, subQuestionIndex, est_marks, docLabel, questionLabel) => {
		const updatedArrayData = { ...opportunityData };
		updatedArrayData.documents[docIndex].questions[questionIndex].sub_questions[subQuestionIndex].current_estimated_marks = e.target.value;
		setOpportunityData(updatedArrayData);

		calcSubmissionScore(docIndex, questionIndex, subQuestionIndex, e.target.value, docLabel, questionLabel, opportunityData)
	}

	const handleInputMaxMarks = (e, docIndex, questionIndex, subQuestionIndex, max_marks, docLabel, questionLabel) => {
		const updatedArrayData = { ...opportunityData };
		updatedArrayData.documents[docIndex].questions[questionIndex].sub_questions[subQuestionIndex].maximum_marks_available = e.target.value;
		setOpportunityData(updatedArrayData);

		calcSubmissionScore(docIndex, questionIndex, subQuestionIndex, e.target.value, docLabel, questionLabel, opportunityData)
	}

	const handleInputMarksAchieved = (e, docIndex, questionIndex, subQuestionIndex, marks, docLabel, questionLabel) => {
		const updatedArrayData = { ...opportunityData };
		updatedArrayData.documents[docIndex].questions[questionIndex].sub_questions[subQuestionIndex].marks_achieved = e.target.value;
		setOpportunityData(updatedArrayData);

		calcSubmissionScore(docIndex, questionIndex, subQuestionIndex, e.target.value, docLabel, questionLabel, opportunityData)
	}

	const showSubmissionPopup = (isEdit, docIndex, questionIndex, subQuestionIndex, section) => {
		var docData = {};

		if (isEdit) {
			setEditDoc(true)
		} else {
			setEditDoc(false)
		}

		if (!_.isEmpty(section.questions[questionIndex].sub_questions[subQuestionIndex].files)) {
			section.questions[questionIndex].sub_questions[subQuestionIndex].files.forEach((e, index) => {
				if (e.name == undefined) {
					section.questions[questionIndex].sub_questions[subQuestionIndex].files.splice(index, 1);
				}
			});
			setAttachment(section.questions[questionIndex].sub_questions[subQuestionIndex].files);
		} else {
			setAttachment([])
		}
		docData = {
			docIndex: docIndex,
			questionIndex: questionIndex,
			subQuestionIndex: subQuestionIndex,
			doctype: section.document_type,
			doctypeLabel: section.label,
			question: section.questions[questionIndex].question_name,
			sub_question_name: section.questions[questionIndex].sub_questions[subQuestionIndex].sub_question_name,
			guidance: section.questions[questionIndex].sub_questions[subQuestionIndex].guidance,
		};
		setDocData(docData)
	}

	const removeSubQuestion = (docIndex, questionIndex, subQuestionIndex) => {
		opportunityData.documents[docIndex].questions[questionIndex].sub_questions.splice(subQuestionIndex, 1);
		setOpportunityData(opportunityData)
		calcSubmissionScore(0, 0, 0, '', '', '', opportunityData);
	}

	const closeDocPopup = () => {
		setAttachment([{}]);
		setTempDelete([]);
		setSubmissionManagementModal(false)
	}

	// const deleteFiles = async () => {
	// 	var res = await deleteFile(tempDelete)
	// 	if (res.data.success == true) {
	// 		setTempDelete([]);
	// 	}
	// };

	const deleteFiles = async () => {
		try {
			// Check if there are files to delete
			if (tempDelete.length === 0) {
				toastRef.current.showToast({
					type: "warning",
					message: "No files selected for deletion.",
				});
				return; // Exit early if no files to delete
			}

			// Call the delete file API
			const res = await deleteFile(tempDelete);

			// Check if the response indicates success
			if (res?.data?.success) {
				setTempDelete([]); // Clear the temporary delete state
				toastRef.current.showToast({
					type: "success",
					message: "Files deleted successfully.",
				});
			} else {
				// Show error message if deletion was not successful
				toastRef.current.showToast({
					type: "error",
					message: res?.data?.message || "Failed to delete files. Please try again.",
				});
			}
		} catch (error) {
			// Handle any errors that occurred during the API call
			toastRef.current.showToast({
				type: "error",
				message: "An error occurred while deleting files. Please try again or contact Admin.",
			});
		}
	};


	const saveDocument = async () => {
		try {
			setLoading(true)
			attachment.length > 0 && attachment.forEach((e, index) => {
				if (e.name == undefined) {
					attachment.splice(index, 1);
				}
			});

			// Update the necessary properties within opportunityData
			opportunityData.documents[docData.docIndex].questions[docData.questionIndex].sub_questions[docData.subQuestionIndex].sub_question_name = docData.sub_question_name;
			opportunityData.documents[docData.docIndex].questions[docData.questionIndex].sub_questions[docData.subQuestionIndex].guidance = docData.guidance;
			opportunityData.documents[docData.docIndex].questions[docData.questionIndex].sub_questions[docData.subQuestionIndex].files = attachment;

			// Set the updated state
			setOpportunityData(prevState => ({
				...prevState,
				documents: [
					...prevState.documents.slice(0, docData.docIndex),
					{
						...prevState.documents[docData.docIndex],
						questions: [
							...prevState.documents[docData.docIndex].questions.slice(0, docData.questionIndex),
							{
								...prevState.documents[docData.docIndex].questions[docData.questionIndex],
								sub_questions: [
									...prevState.documents[docData.docIndex].questions[docData.questionIndex].sub_questions.slice(0, docData.subQuestionIndex),
									{
										...prevState.documents[docData.docIndex].questions[docData.questionIndex].sub_questions[docData.subQuestionIndex],
										sub_question_name: docData.sub_question_name,
										guidance: docData.guidance,
										files: attachment,
									},
									...prevState.documents[docData.docIndex].questions[docData.questionIndex].sub_questions.slice(docData.subQuestionIndex + 1)
								]
							},
							...prevState.documents[docData.docIndex].questions.slice(docData.questionIndex + 1)
						]
					},
					...prevState.documents.slice(docData.docIndex + 1)
				]
			}));

			var data = await saveDoc(curCustomer, opportunityData._id, opportunityData.documents)
			if (data.data.success == true) {
				setSubmissionManagementModal(false)
				toastRef.current.showToast({
					type: 'success',
					message: "Document Updated Successfully"
				});
				deleteFiles();
			} else {
				toastRef.current.showToast({
					type: 'error',
					message: "Error occured while updation"
				});
			}
		} catch (error) {
			toastRef.current.showToast({
				type: 'error',
				message: "Error occured while saving. Please try again or contact Admin"
			});
		} finally {
			setLoading(false)
		}
	}

	const renderFooter = () => {
		return (
			<div className="cancel-footer">
				<div className="align-center justify-end pb-0">
					{
						editDoc ?
							<>
								<ButtonElement label="Cancel" className="cancel-new-button" onClick={() => closeDocPopup()} />
								<ButtonElement type="submit" label="Save" className="save-button" onClick={() => saveDocument()} />
							</>
							:
							<ButtonElement type="submit" label="Cancel" className="cancel-new-button" onClick={() => closeDocPopup()} />
					}
				</div>
			</div>
		);
	};

	const removeImage = (index) => {
		const updatedAttachment = [...attachment]; // Create a copy of the attachment array

		if (updatedAttachment[index]?.name !== undefined) {
			const updatedTempDelete = [...tempDelete, updatedAttachment[index].name]; // Add the name to tempDelete array immutably
			setTempDelete(updatedTempDelete);
		}

		updatedAttachment.splice(index, 1); // Remove the item from the copied array
		setAttachment(updatedAttachment); // Set the state with the new array
	};

	const removeTemplate = (rowData, index) => {
		return <InputIcon
			className="pi pi-trash ml-0 pointer"
			onClick={() => removeImage(index.rowIndex)}
		/>
	}

	const sizeTemplate = (rowData) => {
		return (rowData.size / 1024 / 1024).toPrecision(2)
	}

	const openImage = (url) => {
		window.location.href = url;
	}

	const downloadTemplate = (rowData, index) => {
		return <InputIcon
			className="pi pi-download ml-0 pointer"
			onClick={() => openImage(rowData.url, index.rowIndex)}
		/>
	}

	const columns = [
		{ field: "fileName", header: "Name", headerClassName: "header-datatable", className: 'row-datatable' },
		{ field: "size", header: "Size (MB)", body: sizeTemplate, headerClassName: "header-datatable", className: 'row-datatable' },
		{ field: "type", header: "Type", headerClassName: "header-datatable", className: 'row-datatable' },
		{ field: "url", header: "Download", body: downloadTemplate, headerClassName: "header-datatable", className: 'row-datatable' },
		{ field: "remove", header: "Remove", body: removeTemplate, headerClassName: "header-datatable", className: 'row-datatable' },
	]

	const columns1 = [
		{ field: "fileName", header: "Name", headerClassName: "header-datatable", className: 'row-datatable' },
		{ field: "size", header: "Size (MB)", body: sizeTemplate, headerClassName: "header-datatable", className: 'row-datatable' },
		{ field: "type", header: "Type", headerClassName: "header-datatable", className: 'row-datatable' },
		{ field: "url", header: "Download", body: downloadTemplate, headerClassName: "header-datatable", className: 'row-datatable' },
	]

	const filterSubData = (value, statusValue) => {
		value.length > 0 ? setSelectedOwner(value) : setSelectedOwner([])
		statusValue.length > 0 ? setSelectedStatus(statusValue) : setSelectedStatus([])

		setOpportunityData(prevOpportunityData => {
			const updatedData = { ...prevOpportunityData }; // Make a copy of the previous state

			for (var doc = 0; doc < updatedData.documents.length; doc++) {
				for (var ques = 0; ques < updatedData.documents[doc].questions.length; ques++) {
					for (var subQues = 0; subQues < updatedData.documents[doc].questions[ques].sub_questions.length; subQues++) {
						var isSubAOMatching = false,
							isSubStatMatching = false;
						for (var ao = 0; ao < value.length; ao++) {
							if (updatedData.documents[doc].questions[ques].sub_questions[subQues].action_owner == value[ao]._id) {
								isSubAOMatching = true;
								break;
							}
						}
						for (var stat = 0; stat < statusValue.length; stat++) {
							if (updatedData.documents[doc].questions[ques].sub_questions[subQues].status == statusValue[stat]._id) {
								isSubStatMatching = true;
								break;
							}
						}
						if (value.length == 0 && statusValue.length == 0)
							updatedData.documents[doc].questions[ques].sub_questions[subQues].showSubQues = true;
						else if (value.length > 0 && statusValue.length > 0)
							updatedData.documents[doc].questions[ques].sub_questions[subQues].showSubQues = isSubAOMatching && isSubStatMatching;
						else if (value.length > 0 || statusValue.length > 0)
							updatedData.documents[doc].questions[ques].sub_questions[subQues].showSubQues = isSubAOMatching || isSubStatMatching;
					}
					if (value.length == 0 && statusValue.length == 0)
						updatedData.documents[doc].questions[ques].showQues = true;
					else {
						var records = _.find(updatedData.documents[doc].questions[ques].sub_questions, { showSubQues: true });
						if (!_.isEmpty(records)) {
							updatedData.documents[doc].questions[ques].showQues = true;
						} else {
							updatedData.documents[doc].questions[ques].showQues = false;
						}
					}
				}
				if (value.length == 0 && statusValue.length == 0)
					updatedData.documents[doc].showDoc = true;
				else {
					var records = _.find(updatedData.documents[doc].questions, { showQues: true });
					if (!_.isEmpty(records)) {
						updatedData.documents[doc].showDoc = true;
					} else {
						updatedData.documents[doc].showDoc = false;
					}
				}
			}

			return updatedData;
		});
	};

	const closeSubmissionCompleted = () => {
		var PParentIndex = docDataTemp.PParentIndex;
		var parentIndex = docDataTemp.parentIndex;
		var index = docDataTemp.index;

		const previousStatus = previousStatusData.documents[PParentIndex].questions[parentIndex].sub_questions[index].status;

		opportunityData.documents[PParentIndex].questions[parentIndex].sub_questions[index].status = previousStatus;
		setOpportunityData(opportunityData)
		setSubmissionManagementCompletedModal(false)
	}

	// const modalSubmissionCompleted = async () => {
	// 	var PParentIndex = docDataTemp.PParentIndex;
	// 	var parentIndex = docDataTemp.parentIndex;
	// 	var index = docDataTemp.index;

	// 	var tmpSubmissionData = _.cloneDeep(opportunityData.documents[PParentIndex].questions[parentIndex].sub_questions[index]);

	// 	var data = await submissionActionComplete(opportunityData._id, curCustomer, PParentIndex, parentIndex, index, tmpSubmissionData)
	// 	if (data.data.success) {
	// 		var clearCompNotify = await clearCompletedNotification(tmpSubmissionData._id)
	// 		if (clearCompNotify.data) {
	// 			if (clearCompNotify.data.status) {
	// 				socket.emit('pushNotifications', curCustomer)
	// 			}
	// 		}
	// 		setSubmissionManagementCompletedModal(false)
	// 		toastRef.current.showToast({
	// 			type: 'success',
	// 			message: data.data.message
	// 		});
	// 	}
	// }
	const modalSubmissionCompleted = async () => {
		try {
			setLoading(true); // Start loading spinner

			const PParentIndex = docDataTemp.PParentIndex;
			const parentIndex = docDataTemp.parentIndex;
			const index = docDataTemp.index;

			// Clone the current submission data to avoid mutating the original state
			const tmpSubmissionData = _.cloneDeep(opportunityData.documents[PParentIndex].questions[parentIndex].sub_questions[index]);

			// Call API to mark the submission as completed
			const data = await submissionActionComplete(opportunityData._id, curCustomer, PParentIndex, parentIndex, index, tmpSubmissionData);

			// Check if the API response indicates success
			if (data?.data?.success) {
				// Clear completed notification for the submission
				const clearCompNotify = await clearCompletedNotification(tmpSubmissionData._id);

				// If the notification response is valid, emit the notification event
				if (clearCompNotify?.data?.status) {
					socket.emit('pushNotifications', curCustomer);
				}

				setSubmissionManagementCompletedModal(false);

				// Show success toast notification
				toastRef.current.showToast({
					type: 'success',
					message: data.data.message
				});
			} else {
				toastRef.current.showToast({
					type: 'error',
					message: 'Failed to complete the submission. Please try again or contact Admin.'
				});
			}
		} catch (error) {
			// Handle any errors that occur during the API requests
			toastRef.current.showToast({
				type: 'error',
				message: 'An error occurred while completing the submission. Please try again or contact Admin.'
			});
		} finally {
			setLoading(false);
		}
	};


	const renderCompletedFooter = () => {
		return (
			<div className="cancel-footer">
				<div className="align-center justify-end pb-0">
					{
						isUserActionOwnerSameSub ?
							<>
								<ButtonElement label="No" className="cancel-new-button" onClick={() => closeSubmissionCompleted()} />
								<ButtonElement type="submit" label="Yes" className="save-button" onClick={() => modalSubmissionCompleted()} />
							</>
							:
							<ButtonElement type="submit" label="Close" className="save-button" onClick={() => closeSubmissionCompleted()} />
					}
				</div>
			</div>
		);
	};

	const uploadFile = () => {
		setUpload(true)
	}

	const attachmentData = (data) => {
		setAttachment((prevState) => ([
			...prevState,
			data
		]))
	}

	const onCloseUploadPopup = () => {
		setUpload(false);
	};

	const dropdownRef = useRef(null);
	const handleOutsideClick = (event) => {
		if (showDropdown) {
			const target = event.target;
			const dropdownButton = document.querySelector('.clear-filter-button');
			const dropdownContent = document.querySelector('.s-field');
			const multiSelectInput = document.querySelector('.p-multiselect-filter');

			// Check if the clicked element is not in the dropdown, the button, or any MultiSelect/single select items
			if (
				!dropdownContent.contains(target) &&
				target !== dropdownButton &&
				target !== multiSelectInput &&
				!target.closest('.p-multiselect-item') && // MultiSelect items
				!target.closest('.p-dropdown-item') // Single select dropdown items
			) {
				setShowDropdown(false);
			}
		}
	};

	useEffect(() => {
		document.addEventListener('mousedown', handleOutsideClick);

		return () => {
			document.removeEventListener('mousedown', handleOutsideClick);
		};
	}, [showDropdown]);

	const handleButtonClick = () => {
		setShowVideo(true);
	};

	const closeVideo = () => {
		setShowVideo(false);
	};


	return (
		<div>
			<ToastElement ref={toastRef} />
			<Loader loading={loading} />
			{
				<form>
					<div className="form-group row align-items-center mb-0">
						<div className="col-md-4 pl-0">
							<p className="label-text">
								{_.find(props?.fieldData?.pipelineSubSections, { section_name: "Document Management" })?.display_name}
							</p>
						</div>
						<div className="col-md-8 text-right">
							<ButtonElement className="upload-button" type="button" icon="pi pi-video" onClick={handleButtonClick}></ButtonElement>
						</div>
					</div>
					{
						Object.entries(newModule)?.map(([key, value]) => (
							<div key={key} className='mt-10'>
								<Accordion activeIndex={0}>
									{
										<AccordionTab header={value} disabled>
											{
												key == 'obj1' &&
												<div className='new-field d-flex'>
													<div className='col-md-6 pl-0'>
														{
															_.find(props.fieldData.projectDetailFields, { field_name: "Project/EOI Received Date" })?.field_status &&
															<div className="form-group row align-items-center mb-0 mt-0">
																<div className="col-md-4 pl-0">
																	<label className="form-label text-left">{_.find(props.fieldData.projectDetailFields, { field_name: "Project/EOI Received Date" })?.display_name}</label>
																</div>
																<div className="col-md-1 pl-0">
																	{
																		props.customerTooltipDataDetails?.critical_data.eoi_received_date.status == true &&
																		<div>
																			<Tooltip target=".custom-target-icon" />

																			<i className="custom-target-icon pi pi-info-circle tooltip-font"
																				data-pr-tooltip={props.customerTooltipDataDetails?.critical_data.eoi_received_date.text}
																				data-pr-position="right">
																			</i>
																		</div>
																	}
																</div>
																<div className='col-md-4 pr-0'>
																	<RadioElement
																		id="eoi_received_date"
																		options={[{ key: "Est", name: "Est" }, { key: "Act", name: "Act" }]}
																		value={opportunityData.detail?.eoi_received_date?.radio}
																		onChangeRadio={(value) => {
																			handleInputChange("detail", "eoi_received_date", value);
																		}}
																		className="radio-group-class"
																	/>
																</div>
																<div className='col pr-0'>
																	<CalendarElement
																		id="eoi_received_date"
																		className='ml-10'
																		value={parseDateString(opportunityData.detail?.eoi_received_date?.text)}
																		onChange={(value) => {
																			handleCalenderInputChange("detail", "eoi_received_date", formatDate(value.value));
																		}}
																		maxLength="50"
																		placeholder="Date"
																		autocomplete="off"
																	/>
																</div>
															</div>
														}
														{
															_.find(props.fieldData.projectDetailFields, { field_name: "PQQ Issue Date" })?.field_status &&
															<div className="form-group row align-items-center mb-0 mt-0">
																<div className="col-md-4 pl-0">
																	<label className="form-label text-left">{_.find(props.fieldData.projectDetailFields, { field_name: "PQQ Issue Date" })?.display_name}</label>
																</div>
																<div className="col-md-1 pl-0">
																	{
																		props.customerTooltipDataDetails?.critical_data.pqq_issue_date.status == true &&
																		<div>
																			<Tooltip target=".custom-target-icon" />

																			<i className="custom-target-icon pi pi-info-circle tooltip-font"
																				data-pr-tooltip={props.customerTooltipDataDetails?.critical_data.pqq_issue_date.text}
																				data-pr-position="right">
																			</i>
																		</div>
																	}
																</div>
																<div className='col-md-4 pr-0'>
																	<RadioElement
																		id="pqq_issue_date"
																		options={[{ key: "Est", name: "Est" }, { key: "Act", name: "Act" }]}
																		value={opportunityData.detail?.pqq_issue_date?.radio}
																		onChangeRadio={(value) => {
																			handleInputChange("detail", "pqq_issue_date", value);
																		}}
																		className="radio-group-class"
																	/>
																</div>
																<div className='col pr-0'>
																	<CalendarElement
																		id="pqq_issue_date"
																		className='ml-10'
																		defaultValue={parseDateString(opportunityData.detail?.pqq_issue_date?.text)}
																		value={parseDateString(opportunityData.detail?.pqq_issue_date?.text)}
																		onChange={(value) => {
																			handleCalenderInputChange("detail", "pqq_issue_date", formatDate(value.value));
																		}}
																		maxLength="50"
																		placeholder="Date"
																		autocomplete="off"
																	/>
																</div>
															</div>
														}
														{
															_.find(props.fieldData.projectDetailFields, { field_name: "PQQ Submission Date" })?.field_status &&
															<div className="form-group row align-items-center mb-0 mt-0">
																<div className="col-md-4 pl-0">
																	<label className="form-label text-left">{_.find(props.fieldData.projectDetailFields, { field_name: "PQQ Submission Date" })?.display_name}</label>
																</div>
																<div className="col-md-1 pl-0">
																	{
																		props.customerTooltipDataDetails?.critical_data.pqq_submission_date.status == true &&
																		<div>
																			<Tooltip target=".custom-target-icon" />

																			<i className="custom-target-icon pi pi-info-circle tooltip-font"
																				data-pr-tooltip={props.customerTooltipDataDetails?.critical_data.pqq_submission_date.text}
																				data-pr-position="right">
																			</i>
																		</div>
																	}
																</div>
																<div className='col-md-4 pr-0'>
																	<RadioElement
																		id="pqq_submission_date"
																		options={[{ key: "Est", name: "Est" }, { key: "Act", name: "Act" }]}
																		value={opportunityData.detail?.pqq_submission_date?.radio}
																		onChangeRadio={(value) => {
																			handleInputChange("detail", "pqq_submission_date", value);
																		}}
																		className="radio-group-class"
																	/>
																</div>
																<div className='col pr-0'>
																	<CalendarElement
																		id="pqq_submission_date"
																		className='ml-10'
																		defaultValue={parseDateString(opportunityData.detail?.pqq_submission_date?.text)}
																		value={parseDateString(opportunityData.detail?.pqq_submission_date?.text)}
																		onChange={(value) => {
																			handleCalenderInputChange("detail", "pqq_submission_date", formatDate(value.value));
																		}}
																		maxLength="50"
																		placeholder="Date"
																		autocomplete="off"
																	/>
																</div>
															</div>
														}
														{
															_.find(props.fieldData.projectDetailFields, { field_name: "ITT Issue Date" })?.field_status &&
															<div className="form-group row align-items-center mb-0 mt-0">
																<div className="col-md-4 pl-0">
																	<label className="form-label text-left">{_.find(props.fieldData.projectDetailFields, { field_name: "ITT Issue Date" })?.display_name}</label>
																</div>
																<div className="col-md-1 pl-0">
																	{
																		props.customerTooltipDataDetails?.critical_data.itt_issue_date.status == true &&
																		<div>
																			<Tooltip target=".custom-target-icon" />

																			<i className="custom-target-icon pi pi-info-circle tooltip-font"
																				data-pr-tooltip={props.customerTooltipDataDetails?.critical_data.itt_issue_date.text}
																				data-pr-position="right">
																			</i>
																		</div>
																	}
																</div>
																<div className='col-md-4 pr-0'>
																	<RadioElement
																		id="tender_due"
																		options={[{ key: "Est", name: "Est" }, { key: "Act", name: "Act" }]}
																		value={opportunityData?.tender_due?.radio}
																		onChangeRadio={(value) => {
																			handleTenderInputChange("tender_due", value);
																		}}
																		className="radio-group-class"
																	/>
																</div>
																<div className='col pr-0'>
																	<CalendarElement
																		id="tender_due"
																		className='ml-10'
																		defaultValue={parseDateString(opportunityData?.tender_due?.text)}
																		value={parseDateString(opportunityData?.tender_due?.text)}
																		onChange={(value) => {
																			handleCalenderTenderInputChange("tender_due", formatDate(value.value));
																		}}
																		maxLength="50"
																		placeholder="Date"
																		autocomplete="off"
																	/>
																</div>
															</div>
														}
														{
															_.find(props.fieldData.projectDetailFields, { field_name: "ITT Submission Date" })?.field_status &&
															<div className="form-group row align-items-center mb-0 mt-0">
																<div className="col-md-4 pl-0">
																	<label className="form-label text-left">{_.find(props.fieldData.projectDetailFields, { field_name: "ITT Submission Date" })?.display_name}</label>
																</div>
																<div className="col-md-1 pl-0">
																	{
																		props.customerTooltipDataDetails?.critical_data.itt_submission_date.status == true &&
																		<div>
																			<Tooltip target=".custom-target-icon" />

																			<i className="custom-target-icon pi pi-info-circle tooltip-font"
																				data-pr-tooltip={props.customerTooltipDataDetails?.critical_data.itt_submission_date.text}
																				data-pr-position="right">
																			</i>
																		</div>
																	}
																</div>
																<div className='col-md-4 pr-0'>
																	<RadioElement
																		id="tender_due"
																		options={[{ key: "Est", name: "Est" }, { key: "Act", name: "Act" }]}
																		value={opportunityData.detail?.itt_submission_date?.radio}
																		onChangeRadio={(value) => {
																			handleInputChange("detail", "itt_submission_date", value);
																		}}
																		className="radio-group-class"
																	/>
																</div>
																<div className='col pr-0'>
																	<CalendarElement
																		id="tender_due"
																		className='ml-10'
																		defaultValue={parseDateString(opportunityData.tender_due_out?.text)}
																		value={parseDateString(opportunityData.tender_due_out?.text)}
																		onChange={(value) => {
																			handleCalenderTenderInputChange("tender_due_out", formatDate(value.value));
																		}}
																		maxLength="50"
																		placeholder="Date"
																		autocomplete="off"
																	/>
																</div>
															</div>
														}
													</div>
													<div className='col-md-6 pl-0'>
														{
															_.find(props.fieldData.pipelineSubFields, { field_name: "PQQ Status" })?.field_status &&
															<div>
																<div className="form-group row align-items-center mb-0 mt-0">
																	<div className="col-md-4 pl-0">
																		<label className="form-label text-left">{_.find(props.fieldData.pipelineSubFields, { field_name: "PQQ Status" })?.display_name}:</label>
																	</div>
																</div>
																<div className="form-group row align-items-center mb-0 mt-0">
																	<div className="col-md-1 pl-0"></div>
																	<div className="col-md-5 pl-0">
																		<label className="form-label text-left">Completion: </label>
																	</div>
																	<div className="col pl-0">
																		<label className="form-label text-left">{pqqStatus.completion}%</label>
																	</div>
																</div>
																<div className="form-group row align-items-center mb-0 mt-0">
																	<div className="col-md-1 pl-0"></div>
																	<div className="col-md-5 pl-0">
																		<label className="form-label text-left">Current Estimated Marks: </label>
																	</div>
																	<div className="col pl-0">
																		<label className="form-label text-left">{pqqStatus.sumOfEstimatedMarks + " / " + pqqStatus.sumOfMaxMarks}</label>
																	</div>
																</div>
																<div className="form-group row align-items-center mb-0 mt-0">
																	<div className="col-md-1 pl-0"></div>
																	<div className="col-md-5 pl-0">
																		<label className="form-label text-left">Marks Achieved: </label>
																	</div>
																	<div className="col pl-0">
																		<label className="form-label text-left">{pqqStatus.sumOfMarksAchieved + " / " + pqqStatus.sumOfMaxMarks}</label>
																	</div>
																</div>
															</div>
														}
														{
															_.find(props.fieldData.pipelineSubFields, { field_name: "ITT Status" })?.field_status &&
															<div>
																<div className="form-group row align-items-center mb-0 mt-0">
																	<div className="col-md-4 pl-0">
																		<label className="form-label text-left">{_.find(props.fieldData.pipelineSubFields, { field_name: "ITT Status" })?.display_name}:</label>
																	</div>
																</div>
																<div className="form-group row align-items-center mb-0 mt-0">
																	<div className="col-md-1 pl-0"></div>
																	<div className="col-md-5 pl-0">
																		<label className="form-label text-left">Completion: </label>
																	</div>
																	<div className="col pl-0">
																		<label className="form-label text-left">{ittStatus.completion}%</label>
																	</div>
																</div>
																<div className="form-group row align-items-center mb-0 mt-0">
																	<div className="col-md-1 pl-0"></div>
																	<div className="col-md-5 pl-0">
																		<label className="form-label text-left">Current Estimated Marks: </label>
																	</div>
																	<div className="col pl-0">
																		<label className="form-label text-left">{ittStatus.sumOfEstimatedMarks + " / " + ittStatus.sumOfMaxMarks}</label>
																	</div>
																</div>
																<div className="form-group row align-items-center mb-0 mt-0">
																	<div className="col-md-1 pl-0"></div>
																	<div className="col-md-5 pl-0">
																		<label className="form-label text-left">Marks Achieved: </label>
																	</div>
																	<div className="col pl-0">
																		<label className="form-label text-left">{ittStatus.sumOfMarksAchieved + " / " + ittStatus.sumOfMaxMarks}</label>
																	</div>
																</div>
															</div>
														}
													</div>
												</div>
											}
											{
												key == 'obj2' &&
												<div className="new-field group-table-component">
													{
														_.find(props.fieldData.oppSubmissionManagementTable, { table_name: "Document Response Management" })?.status &&
														<>
															<div className="form-group row align-items-center mb-0">
																<div className="col pr-0 d-flex justify-end">
																	<ButtonElement type='button' icon="pi pi-filter-slash" className="edit-option-button font-text" onClick={resetButton} />
																	<div className='p-relative ml-20' ref={dropdownRef}>
																		<ButtonElement type='button' className="edit-option-button" icon="pi pi-filter" onClick={toggleDropdown} />
																		{
																			showDropdown && (
																				<>
																					<div className='s-field'>
																						<div className='new-field w-100'>
																							<div className="form-group row align-items-center mb-0 mt-0">
																								<div className="col-md-5 pl-0">
																									<label className="form-label text-left">
																										Action Owner:
																									</label>
																								</div>
																								<div className="col pr-0">
																									<MultiSelectElement
																										value={selectedOwner}
																										optionLabel="label"
																										options={props.relationshipOwner}
																										placeholder="-- Please select --"
																										maxSelectedLabels={1}
																										onChangeValue={(e) => filterSubData(e.value, selectedStatus)}
																										className="w-full"
																									/>
																								</div>
																							</div>
																							<div className="form-group row align-items-center mb-0 mt-0">
																								<div className="col-md-5 pl-0">
																									<label className="form-label text-left">
																										Status:
																									</label>
																								</div>
																								<div className="col pr-0">
																									<MultiSelectElement
																										value={selectedStatus}
																										optionLabel="label"
																										options={props.submissionDocStatus}
																										placeholder="-- Please select --"
																										maxSelectedLabels={1}
																										onChangeValue={(e) => filterSubData(selectedOwner, e.value)}
																										className="w-full"
																									/>
																								</div>
																							</div>
																						</div>
																					</div>
																				</>
																			)
																		}
																	</div>
																	<ButtonElement type="button" className="edit-option-button ml-20" icon="pi pi-trash" onClick={removeSelected} />
																	<ButtonElement type="button" className="edit-option-button ml-20" icon="pi pi-plus" onClick={addNew} />
																</div>
															</div>
															<div className="group-table-data risks-tab">
																<table className="group-datatable">
																	<thead className="group-table-header white-space">
																		<tr>
																			<th className="checkbox-header"></th>
																			<th className='width-10'>{_.find(props.fieldData.oppSubmissionManagementHeaders, { header_name: 'Section' })?.display_name}</th>
																			<th className='width-5'>{_.find(props.fieldData.oppSubmissionManagementHeaders, { header_name: 'Description' })?.display_name}</th>
																			<th className='width-10'>{_.find(props.fieldData.oppSubmissionManagementHeaders, { header_name: 'Action Owner' })?.display_name}</th>
																			<th className='width-10'>{_.find(props.fieldData.oppSubmissionManagementHeaders, { header_name: 'Action By Date' })?.display_name}</th>
																			<th className='width-10'>{_.find(props.fieldData.oppSubmissionManagementHeaders, { header_name: 'Status' })?.display_name}</th>
																			<th className='width-10'>{_.find(props.fieldData.oppSubmissionManagementHeaders, { header_name: 'Current Estimated Marks' })?.display_name}</th>
																			<th className='width-10'>{_.find(props.fieldData.oppSubmissionManagementHeaders, { header_name: 'Maximum Marks Available' })?.display_name}</th>
																			<th className='width-10'>{_.find(props.fieldData.oppSubmissionManagementHeaders, { header_name: 'Estimated Score' })?.display_name}</th>
																			<th className='width-5'>{_.find(props.fieldData.oppSubmissionManagementHeaders, { header_name: 'Marks Achieved' })?.display_name}</th>
																			<th className='width-10'>{_.find(props.fieldData.oppSubmissionManagementHeaders, { header_name: 'Guidance' })?.display_name}</th>
																			<th colSpan={3} className="checkbox-header"></th>
																		</tr>
																	</thead>
																	<tbody className="group-table-row stakeplan">
																		{
																			opportunityData.documents?.map((section, ind) => {
																				if (section.showDoc != false) {
																					return (
																						<React.Fragment>
																							<tr>
																								<td className="group-header">
																									<CheckboxElement
																										id={`doc-${ind}`}
																										name={`doc-${ind}`}
																										checked={section.checked}
																										onChangeCheck={(e) => singleSelectDoc(ind, opportunityData.documents, e)}
																										className="mr-2"
																									/>
																								</td>
																								<td className="width-10 group-header" colSpan={11}>
																									<label className='form-label text-left font-bold'>{section.label}</label>
																								</td>
																							</tr>
																							{
																								section.questions?.map((question, questionIndex) => (
																									question.showQues != false &&
																									<tr>
																										<td>
																											<CheckboxElement
																												id={`known-${questionIndex}`}
																												name={`known-${questionIndex}`}
																												checked={question.checked}
																												onChangeCheck={(e) => singleSelectQuestion(ind, questionIndex, section, opportunityData.documents, e)}
																												className="mr-2"
																											/>
																										</td>
																										<td className='width-10'>
																											<InputTextElementElement
																												id="question_name"
																												name="question_name"
																												value={question.question_name}
																												onChange={(e) => handleInputChangeName(e, ind, questionIndex)}
																												required
																											/>
																										</td>
																										<td colSpan={10}>
																											{
																												question.sub_questions?.map((sub_question, subQuestionIndex) => {
																													const checkList = sub_question.action_owner;

																													const matched = props.relationshipOwner.find(
																														(item) => item._id === checkList
																													);

																													const status = sub_question.status;

																													const matched_status = props.submissionDocStatus.find(
																														(item) => item._id === status
																													);

																													const subQuestionNumber = `${questionIndex + 1}.${subQuestionIndex + 1}`;

																													if (sub_question.showSubQues !== false) {
																														return (
																															<tr>
																																<td className='width-5'>
																																	<label className='form-label text-left'>{subQuestionNumber + ') '}</label>
																																	<label className="className='form-label text-left'" >
																																		{sub_question.sub_question_name && sub_question.sub_question_name.slice(0, 25)}
																																	</label>
																																	{sub_question.sub_question_name && sub_question.sub_question_name.length > 25 && <span className='form-label text-left'>...</span>}
																																</td>
																																<td className='width-10'>
																																	<SingleSelectElement
																																		id='action_owner'
																																		name="action_owner"
																																		options={(props.relationshipOwner != undefined && props.relationshipOwner.length > 0) ? props.relationshipOwner : []}
																																		optionLabel="label"
																																		value={matched ? matched : null}
																																		onChangeValue={(e) => handlePerson(e, ind, questionIndex, subQuestionIndex)}
																																		placeholder="-- Please select --"
																																		maxSelectedLabels={1}
																																		className="w-150"
																																	/>
																																</td>
																																<td className='width-10'>
																																	<CalendarElement
																																		id="action_bydate"
																																		placeholder="Choose a date"
																																		value={parseDateString(sub_question.action_bydate)}
																																		onChange={(e) => handleDate(e, ind, questionIndex, subQuestionIndex)}
																																		readOnlyInput
																																	/>
																																</td>
																																<td className='width-10'>
																																	<SingleSelectElement
																																		id='status'
																																		name="status"
																																		options={(props.submissionDocStatus != undefined && props.submissionDocStatus.length > 0) ? props.submissionDocStatus : []}
																																		optionLabel="label"
																																		value={matched_status ? matched_status : null}
																																		onChangeValue={(e) => handleStatus(e, ind, questionIndex, subQuestionIndex, sub_question.status, section.label, question.question_name)}
																																		placeholder="-- Please select --"
																																		maxSelectedLabels={1}
																																		className="w-150"
																																	/>
																																</td>
																																<td className='width-10'>
																																	<InputTextElementElement
																																		id="current_estimated_marks"
																																		name="current_estimated_marks"
																																		value={sub_question.current_estimated_marks}
																																		onChange={(e) => handleInputEstMarks(e, ind, questionIndex, subQuestionIndex, sub_question.current_estimated_marks, section.label, question.question_name)}
																																		required
																																	/>
																																</td>
																																<td className='width-10'>
																																	<InputTextElementElement
																																		id="maximum_marks_available"
																																		name="maximum_marks_available"
																																		value={sub_question.maximum_marks_available}
																																		onChange={(e) => handleInputMaxMarks(e, ind, questionIndex, subQuestionIndex, sub_question.maximum_marks_available, section.label, question.question_name)}
																																		required
																																	/>
																																</td>
																																<td className='width-10'>
																																	<label className='form-label text-left'>{((sub_question.current_estimated_marks) ? sub_question.current_estimated_marks : 0) + "/" + ((sub_question.maximum_marks_available) ? sub_question.maximum_marks_available : 0)}</label>
																																</td>
																																<td className='width-5'>
																																	<InputTextElementElement
																																		id="marks_achieved"
																																		name="marks_achieved"
																																		value={sub_question.marks_achieved}
																																		onChange={(e) => handleInputMarksAchieved(e, ind, questionIndex, subQuestionIndex, sub_question.marks_achieved, section.label, question.question_name)}
																																		required
																																	/>
																																</td>
																																<td className='width-10'>
																																	{
																																		sub_question.guidance &&
																																		<label className='form-label text-left'>{sub_question.guidance}</label>
																																	}
																																</td>
																																<td className='width-10'>
																																	<div className='d-flex'>
																																		<InputIcon
																																			className="pi pi-eye ml-0"
																																			onClick={() => showSubmissionPopup(false, ind, questionIndex, subQuestionIndex, section)}
																																		/>
																																		<InputIcon
																																			className="pi pi-pencil ml-10"
																																			onClick={() => showSubmissionPopup(true, ind, questionIndex, subQuestionIndex, section)}
																																		/>
																																		{
																																			subQuestionIndex != 0 &&
																																			<InputIcon
																																				className="pi pi-trash ml-10"
																																				onClick={() => removeSubQuestion(ind, questionIndex, subQuestionIndex)}
																																			/>
																																		}
																																	</div>
																																</td>
																															</tr>
																														)
																													}
																												})
																											}
																										</td>
																									</tr>
																								))}
																						</React.Fragment>
																					);
																				}
																			})
																		}
																	</tbody>
																</table>
															</div>
														</>
													}
												</div>
											}
										</AccordionTab>
									}
								</Accordion>
							</div>
						)
						)
					}
				</form>
			}
			<Dialog
				header={docData.doctypeLabel + " : " + docData.question}
				visible={submissionManagementModal}
				position="right"
				onHide={() => closeDocPopup()}
				draggable={false}
				resizable={false}
				footer={renderFooter()}
				className="table-dialog width-32"
			>
				<div>
					<div className="form-group row align-items-center mb-0 mt-0">
						<div className="col-md-4 pl-0">
							<label className="form-label text-left font-bold">
								Section
							</label>
						</div>
						<div className="col pr-0">
							<label className="form-label text-left">{docData.question}</label>
						</div>

					</div>
					<div className="form-group row align-items-center mb-0 mt-0">
						<div className="col-md-4 pl-0">
							<label className="form-label text-left font-bold">
								Description
							</label>
						</div>
						<div className="col pr-0">
							{
								editDoc ?
									<TextareaElement
										placeholder="Text"
										name="sub_question_name"
										className="w-full"
										value={docData.sub_question_name}
										onChange={e => setDocData((prevState) => ({
											...prevState,
											sub_question_name: e.target.value
										}))}
										rows={3}
										required
									/> :
									<label className="form-label text-left">
										{docData.sub_question_name}
									</label>
							}

						</div>
					</div>
					<div className="form-group row align-items-center mb-0 mt-0">
						<div className="col-md-4 pl-0">
							<label className="form-label text-left font-bold">
								Guidance
							</label>
						</div>
						<div className="col pr-0">
							{
								editDoc ?
									<TextareaElement
										placeholder="Text"
										name="guidance"
										className="w-full"
										value={docData.guidance}
										onChange={e => setDocData((prevState) => ({
											...prevState,
											guidance: e.target.value
										}))}
										rows={3}
										required
									/> :
									<label className="form-label text-left">
										{docData.guidance}
									</label>
							}

						</div>
					</div>
					<div className="form-group row align-items-center mb-0 mt-0">
						<div className="col-md-4 pl-0">
							<label className="form-label text-left font-bold">
								Attachment(s)
							</label>
						</div>
						<div className="col pr-0">
							{
								editDoc ?
									<ButtonElement type="button" className="save-button" icon="pi pi-upload" onClick={uploadFile} /> :
									""
							}

						</div>
					</div>
					<div className="form-group row align-items-center mb-0 mt-0">
						<div className="col pr-0 pl-0">
							<DataTable
								value={attachment ? attachment : []}
								columns={editDoc ? columns : columns1}
								dataKey="_id"
								isNewField={true}
							/>
						</div>
					</div>
				</div>
			</Dialog>
			<Dialog
				header={"Submission Document: " + docDataTemp.docLabel}
				visible={submissionManagementCompletedModal}
				position="right"
				onHide={() => closeSubmissionCompleted()}
				draggable={false}
				resizable={false}
				footer={renderCompletedFooter()}
				className="table-dialog width-32"
			>
				<div>
					{
						isUserActionOwnerSameSub ? <div className="confirmation-content">
							<span className="table-description">
								Do you want to complete this action?
							</span>
						</div> :
							<div className="confirmation-content">
								<span className="table-description">
									This action belongs to another user. Your are not authorised to complete this action.
								</span>
							</div>

					}
				</div>
			</Dialog>
			<Dialog
				header={"Upload Image"}
				visible={upload}
				position="top"
				className='width-50vw'
				onHide={onCloseUploadPopup}
				draggable={false}
			>
				<ExcelUploader
					onCloseUploadPopup={onCloseUploadPopup}
					pipelineQuestion={true}
					attachmentData={attachmentData}
				/>
			</Dialog>
			<Dialog id="videoModal" visible={showVideo}
				breakpoints={{
					'1200px': '80vw',    // Larger modal on bigger screens
					'1024px': '85vw',    // Slightly smaller for medium screens
					'769': '90vw',     // Responsive on tablets
					'641px': '95vw',     // Almost full-width on mobile
				}}
				modal className="table-dialog width-32" draggable={false} width="800px" height="500px" onHide={closeVideo}
			>
				<div className="video-overlay">
					<div className="video-container">
						<PlaylistVideos playlistId={process.env.REACT_APP_PORTFOLIO_PLAYLIST_ID} apiKey={process.env.REACT_APP_GOOGLE_API_KEY} module="portfolio_questions" />
					</div>
				</div>
			</Dialog>
		</div>
	)
}

export default QuestionAndAnswer